// extracted by mini-css-extract-plugin
export default {"container":"ToggleButton_container__8Wd5r","wrapper":"ToggleButton_wrapper__WlqDS","on":"ToggleButton_on__flXLh","circle":"ToggleButton_circle__KiNOr"};